"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notifications = exports.useNotifications = exports.NotificationsProvider = exports.NotificationsContext = exports.add = exports.remove = exports.CloseButton = void 0;

var _react = _interopRequireWildcard(require("react"));

var _framerMotion = require("framer-motion");

var _ = require("../");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Path = function Path(props) {
  return /*#__PURE__*/_react["default"].createElement(_framerMotion.motion.path, _extends({
    fill: "transparent",
    strokeWidth: "3",
    stroke: "hsl(0, 0%, 18%)",
    strokeLinecap: "round"
  }, props));
};

var CloseButton = function CloseButton(_ref) {
  var close = _ref.close;
  return /*#__PURE__*/_react["default"].createElement(_.View, {
    as: "button",
    extend: [buttonCSS, closeButton],
    onClick: close,
    className: "close"
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: "23",
    height: "23",
    viewBox: "0 0 23 23"
  }, /*#__PURE__*/_react["default"].createElement(Path, {
    d: "M 3 16.5 L 17 2.5"
  }), /*#__PURE__*/_react["default"].createElement(Path, {
    d: "M 3 2.5 L 17 16.346"
  })));
};

exports.CloseButton = CloseButton;

var remove = function remove(arr, item) {
  var newArr = _toConsumableArray(arr);

  newArr.splice(newArr.findIndex(function (i) {
    return i === item;
  }), 1);
  return newArr;
};

exports.remove = remove;
var newIndex = 0;

var add = function add(arr) {
  newIndex++;
  return [].concat(_toConsumableArray(arr), [{
    id: Math.random()
  }]);
};

exports.add = add;
var NotificationsContext = /*#__PURE__*/(0, _react.createContext)({});
exports.NotificationsContext = NotificationsContext;

var NotificationsProvider = function NotificationsProvider(_ref2) {
  var children = _ref2.children;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      notifications = _useState2[0],
      setNotifications = _useState2[1];

  var triggerNotification = (0, _react.useCallback)(function (input) {
    setNotifications([].concat(_toConsumableArray(notifications), [input]));
  }, [notifications]);
  var context = {
    triggerNotification: triggerNotification,
    notifications: notifications,
    setNotifications: setNotifications,
    closeNotification: function closeNotification(id) {
      return setNotifications(remove(notifications, id));
    }
  };
  return /*#__PURE__*/_react["default"].createElement(NotificationsContext.Provider, {
    value: context
  }, /*#__PURE__*/_react["default"].createElement(Notifications, null), children);
};

exports.NotificationsProvider = NotificationsProvider;

var useNotifications = function useNotifications() {
  return (0, _react.useContext)(NotificationsContext);
};

exports.useNotifications = useNotifications;

var Notifications = function Notifications() {
  var _useNotifications = useNotifications(),
      notifications = _useNotifications.notifications,
      setNotifications = _useNotifications.setNotifications;

  return /*#__PURE__*/_react["default"].createElement(_.View, {
    extend: rootCSS
  }, /*#__PURE__*/_react["default"].createElement(_.View, {
    as: "ul",
    extend: notificationsCSS
  }, /*#__PURE__*/_react["default"].createElement(_framerMotion.AnimatePresence, {
    initial: false
  }, notifications.map(function (_ref3) {
    var title = _ref3.title,
        subTitle = _ref3.subTitle,
        id = _ref3.id,
        buttons = _ref3.buttons,
        hideCloseButton = _ref3.hideCloseButton;
    return /*#__PURE__*/_react["default"].createElement(_.View, {
      as: _framerMotion.motion.li,
      extend: notificationCSS,
      key: id,
      layoutTransition: true,
      layout: true,
      initial: {
        opacity: 0,
        y: 50,
        scale: 0.3
      },
      animate: {
        opacity: 1,
        y: 0,
        scale: 1
      },
      exit: {
        opacity: 0,
        scale: 0.5,
        transition: {
          duration: 0.2
        }
      }
    }, /*#__PURE__*/_react["default"].createElement(_.Text, {
      variant: "medium",
      bold: true
    }, title), /*#__PURE__*/_react["default"].createElement(_.Spacer, {
      size: 2
    }), /*#__PURE__*/_react["default"].createElement(_.Text, null, subTitle), /*#__PURE__*/_react["default"].createElement(_.Spacer, {
      size: 4
    }), /*#__PURE__*/_react["default"].createElement(_.View, {
      extend: {
        display: 'flex',
        justifyContent: 'flex-end'
      }
    }, buttons), !hideCloseButton && /*#__PURE__*/_react["default"].createElement(CloseButton, {
      close: function close() {
        return setNotifications(remove(notifications, id));
      }
    }));
  }))), /*#__PURE__*/_react["default"].createElement(_.View, {
    extend: backdropCSS,
    as: _framerMotion.motion.div,
    initial: false,
    animate: {
      opacity: notifications.length ? 1 : 0
    }
  }));
};

exports.Notifications = Notifications;

var rootCSS = function rootCSS() {
  return {
    position: 'fixed',
    bottom: 0,
    right: 0,
    top: 0,
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    zIndex: 10,
    pointerEvents: 'none'
  };
};

var backdropCSS = function backdropCSS(_ref4) {
  var colors = _ref4.theme.colors;
  return {
    position: 'absolute',
    right: 0,
    top: 0,
    background: "linear-gradient(45deg, transparent 60%, ".concat(colors.primary, " 100%)"),
    display: 'flex',
    width: 600,
    height: 600,
    maxWidth: '100%',
    maxHeight: '100%',
    flexDirection: 'column',
    zIndex: 9
  };
};

var notificationsCSS = function notificationsCSS(_ref5) {
  var grid = _ref5.theme.grid;
  return {
    position: 'absolute',
    right: grid,
    top: grid,
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
    listStyle: 'none',
    justifyContent: 'flex-end',
    pointerEvents: 'auto'
  };
};

var notificationCSS = function notificationCSS(_ref6) {
  var _ref6$theme = _ref6.theme,
      layout = _ref6$theme.layout,
      grid = _ref6$theme.grid,
      shadows = _ref6$theme.shadows;
  return {
    width: 300,
    background: 'white',
    margin: grid,
    flex: '0 0 100px',
    position: 'relative',
    borderRadius: layout.radius,
    boxShadow: shadows.big,
    padding: 3 * grid
  };
};

var buttonCSS = {
  outline: 'none',
  '-webkit-appearance': 'none',
  cursor: 'pointer',
  pointerEvents: 'auto'
};

var addCSS = function addCSS(_ref7) {
  var grid = _ref7.theme.grid;
  return {
    position: 'fixed',
    bottom: 2 * grid,
    left: 2 * grid,
    width: 60,
    height: 60,
    borderRadius: '50%',
    fontSize: 28,
    border: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10
  };
};

var closeButton = function closeButton(_ref8) {
  var grid = _ref8.theme.grid;
  return {
    position: 'absolute',
    top: 2 * grid,
    right: grid,
    background: 'white',
    border: 'none'
  };
};